import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M13.75 16.5H9.75V12M9.75 12H4M9.75 12V7.5H13.75M15 10.25H18C18.6904 10.25 19.25 9.69036 19.25 9V6C19.25 5.30964 18.6904 4.75 18 4.75H15C14.3096 4.75 13.75 5.30964 13.75 6V9C13.75 9.69036 14.3096 10.25 15 10.25ZM15 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V15C19.25 14.3096 18.6904 13.75 18 13.75H15C14.3096 13.75 13.75 14.3096 13.75 15V18C13.75 18.6904 14.3096 19.25 15 19.25Z" />
	</SVG>
);
